import { FC } from 'react';
import { useMediaQ } from '../../../../hooks/useMediaQ';
import { Grid } from '../../../layout/grid/Grid';
import { ListItemIconText } from '../ListItemIconText';
import { ListTextColTitle } from './ListTextColTitle';
import { ListTextIconColProps } from './model/ListTextIconColProps';

export const ListTextIconCol: FC<ListTextIconColProps> = ({
  children,
  dash = false,
  hideTitle,
  iconProps,
  size,
  subLabelProps,
  sx,
  text,
  textProps,
  title,
  faulty = false,
  iconTooltip,
  titleProps,
  noWrap,
  onClick,
  required = false,
  tooltipTitle,
  my,
  ...props
}) => {
  const lgUp = useMediaQ('lg', 'up');
  const hideTitleToUse = hideTitle === undefined ? lgUp : hideTitle;
  return (
    <Grid item sx={sx} {...props} my={my}>
      {!hideTitleToUse && title && (
        <ListTextColTitle tooltipTitle={tooltipTitle} textProps={{ color: 'textSecondary', ...titleProps }}>
          {required ? `${title}*` : title}
        </ListTextColTitle>
      )}
      <ListItemIconText
        faulty={faulty}
        size={size}
        dash={dash}
        label={text}
        labelProps={textProps}
        iconTooltip={iconTooltip}
        iconProps={iconProps}
        noWrap={noWrap}
        onClick={onClick}
        {...props}
      />

      {!subLabelProps?.hideSubLabel && subLabelProps && (
        <ListItemIconText
          size={subLabelProps.size ?? 'small'}
          label={subLabelProps.text}
          labelProps={{ color: subLabelProps?.primary ? undefined : 'textSecondary', ...subLabelProps.textProps }}
          iconProps={subLabelProps.iconProps}
        />
      )}
      {children}
    </Grid>
  );
};
